import { format, isSameMonth, isSameYear } from "date-fns";
import { parseCalendarDate } from "@/util/calendarDate";

/**
 * Minimal occurrence shape needed to decide whether finalized dates can be shown.
 */
export interface OccurrenceDateFields {
  start_date_time?: string | null;
  end_date_time?: string | null;
  start_date_time_is_final?: boolean | null;
  end_date_time_is_final?: boolean | null;
}

/**
 * True when an occurrence's start/end dates are both set and both marked final.
 */
export const hasFinalizedOccurrenceDates = (occurrence: OccurrenceDateFields | null | undefined): boolean => {
  return Boolean(
    occurrence?.start_date_time &&
      occurrence?.end_date_time &&
      occurrence.start_date_time_is_final &&
      occurrence.end_date_time_is_final,
  );
};

/**
 * Formats a finalized occurrence date range for display, e.g. "November 3 – 5, 2026" when the
 * range falls within one month, or "November 30 – December 2, 2026" when it spans two months.
 */
export const formatOccurrenceDateRange = (startDateTime: string, endDateTime: string): string => {
  const start = parseCalendarDate(startDateTime);
  const end = parseCalendarDate(endDateTime);

  if (!start || !end) {
    return "";
  }

  if (isSameMonth(start, end) && isSameYear(start, end)) {
    return `${format(start, "MMMM d")} – ${format(end, "d, yyyy")}`;
  }

  if (isSameYear(start, end)) {
    return `${format(start, "MMMM d")} – ${format(end, "MMMM d, yyyy")}`;
  }

  return `${format(start, "MMMM d, yyyy")} – ${format(end, "MMMM d, yyyy")}`;
};
